import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CGV = () => {
  return (
    <div className="min-h-screen bg-[#030303]">
      {/* Header */}
      <div className="border-b border-[#1C1C1C]">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#71717A] hover:text-[#A1A1AA] transition-colors text-sm"
          >
            <ArrowLeft size={16} />
            Retour
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <header className="mb-16 text-center">
          <h1 
            className="text-3xl md:text-4xl text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Conditions Générales de Vente
          </h1>
          <p className="text-[#D4AF37] text-sm tracking-[0.2em] uppercase">
            Clierxter Vision Lab
          </p>
        </header>

        <div className="space-y-12 text-[#A1A1AA] leading-relaxed">
          
          {/* Section 1 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Identification
            </h2>
            <p className="mb-4">
              La marque Clierxter Vision Lab, éditée par Manuela Ellis Manda, propose une plateforme digitale (SaaS) dédiée à la stratégie visuelle, au branding, à la création de contenu et au développement personnel et professionnel des femmes entrepreneures.
            </p>
            <p>
              Email de contact : <a href="mailto:hello@clierxterapp.com" className="text-[#D4AF37] hover:underline">hello@clierxterapp.com</a><br />
              <span className="text-[#71717A] text-sm">(Cette adresse pourra être mise à jour après activation du domaine officiel)</span>
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Objet
            </h2>
            <p className="mb-4">
              Les présentes Conditions Générales de Vente (CGV) régissent l'accès et l'utilisation de la plateforme Clierxter Vision Lab, incluant notamment :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>les outils digitaux (intelligence artificielle, stratégie visuelle, branding)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>les contenus éducatifs et interactifs</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>les programmes et challenges</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>l'accès à la communauté privée</span>
              </li>
            </ul>
            <p className="mt-4">
              Toute souscription implique l'acceptation pleine et entière des présentes CGV.
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Accès et abonnement
            </h2>
            <p className="mb-4">
              L'accès à la plateforme est proposé sous forme d'abonnement :
            </p>
            <ul className="list-none space-y-2 ml-4 mb-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Essentiel</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Vision Lab Expérience</span>
              </li>
            </ul>
            <p className="mb-4">
              Chaque abonnement donne accès à des fonctionnalités spécifiques, détaillées sur la plateforme.
            </p>
            <p>
              L'accès est strictement personnel, non transférable et réservé à un usage individuel.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Prix
            </h2>
            <p className="mb-4">
              Les prix sont indiqués en francs suisses (CHF), toutes taxes comprises (TTC), sauf indication contraire.
            </p>
            <p className="mb-4">
              Les abonnements sont proposés comme suit :
            </p>
            <ul className="list-none space-y-2 ml-4 mb-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Offre Essentiel : prix affiché sur la plateforme</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Offre Vision Lab Expérience : 69 CHF / mois</span>
              </li>
            </ul>
            <p className="mb-4">
              Clierxter Vision Lab se réserve le droit de modifier ses prix à tout moment.
            </p>
            <p>
              Le prix appliqué est celui en vigueur au moment de la souscription.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Paiement
            </h2>
            <p className="mb-4">
              Le paiement est effectué via un prestataire sécurisé, notamment Stripe.
            </p>
            <ul className="list-none space-y-2 ml-4 mb-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>paiement sécurisé</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>prélèvement automatique en cas d'abonnement</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>renouvellement mensuel automatique</span>
              </li>
            </ul>
            <p>
              Selon le pays de l'utilisateur, le paiement peut être effectué dans une devise différente. Dans ce cas, le montant est automatiquement converti par le prestataire de paiement.
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Renouvellement et résiliation
            </h2>
            <p className="mb-4">
              Les abonnements sont renouvelés automatiquement à chaque échéance, sauf résiliation par l'utilisateur avant la date de renouvellement.
            </p>
            <p className="mb-4">
              L'utilisateur peut résilier son abonnement à tout moment depuis son espace personnel.
            </p>
            <p>
              L'accès reste actif jusqu'à la fin de la période déjà payée.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              7. Droit de rétractation
            </h2>
            <p className="mb-4">
              Conformément à la réglementation en vigueur concernant les services numériques :
            </p>
            <p className="text-white bg-[#0A0A0A] border border-[#1C1C1C] p-4">
              L'accès étant fourni immédiatement après paiement, l'utilisateur renonce expressément à son droit de rétractation.
            </p>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              8. Accès au service
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab s'engage à fournir un accès continu à la plateforme.
            </p>
            <p className="mb-4">
              Cependant, des interruptions peuvent survenir pour :
            </p>
            <ul className="list-none space-y-2 ml-4 mb-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>maintenance</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>mise à jour</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>amélioration du service</span>
              </li>
            </ul>
            <p>
              Aucune indemnisation ne pourra être demandée pour ces interruptions temporaires.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              9. Responsabilité de l'utilisateur
            </h2>
            <p className="mb-4">
              L'utilisateur s'engage à :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>fournir des informations exactes</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>ne pas partager ses identifiants</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>utiliser la plateforme de manière responsable et respectueuse</span>
              </li>
            </ul>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              10. Interdictions
            </h2>
            <p className="mb-4">
              Il est strictement interdit de :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>revendre, copier ou reproduire les contenus</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>partager les accès à des tiers</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>détourner les outils à des fins frauduleuses</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>exploiter la plateforme à des fins commerciales non autorisées</span>
              </li>
            </ul>
          </section>

          {/* Section 11 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              11. Communauté
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab propose un espace communautaire permettant les échanges entre membres.
            </p>
            <p className="mb-4">
              Chaque utilisateur s'engage à :
            </p>
            <ul className="list-none space-y-2 ml-4 mb-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>respecter les autres membres</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>ne pas publier de contenu offensant ou inapproprié</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>éviter toute forme de spam ou autopromotion abusive</span>
              </li>
            </ul>
            <p>
              Clierxter Vision Lab se réserve le droit de suspendre ou supprimer l'accès à la communauté en cas de non-respect de ces règles.
            </p>
          </section>

          {/* Section 12 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              12. Propriété intellectuelle
            </h2>
            <p className="mb-4">
              L'ensemble des contenus, outils, textes, visuels et éléments de la plateforme est la propriété exclusive de Clierxter Vision Lab.
            </p>
            <p>
              Toute reproduction, distribution ou utilisation sans autorisation est strictement interdite.
            </p>
          </section>

          {/* Section 13 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              13. Responsabilité
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab propose des outils et contenus à visée éducative et stratégique.
            </p>
            <p className="mb-4">
              Aucun résultat financier, personnel ou professionnel n'est garanti.
            </p>
            <p>
              L'utilisateur reste entièrement responsable de ses décisions, actions et résultats.
            </p>
          </section>

          {/* Section 14 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              14. Données personnelles
            </h2>
            <p>
              Les données personnelles collectées sont traitées conformément à la <Link to="/confidentialite" className="text-[#D4AF37] hover:underline">politique de confidentialité</Link>.
            </p>
          </section>

          {/* Section 15 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              15. Droit applicable
            </h2>
            <p className="mb-4">
              Les présentes CGV sont régies par le droit applicable en Suisse.
            </p>
            <p>
              En cas de litige, une solution amiable sera recherchée en priorité.
            </p>
          </section>

        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-[#1C1C1C] text-center">
          <p className="text-[#52525B] text-sm">
            Clierxter Vision Lab
          </p>
        </footer>
      </div>
    </div>
  );
};

export default CGV;
